import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
} from "@material-tailwind/react";
import Chart from "react-apexcharts";
import { Square3Stack3DIcon } from "@heroicons/react/24/outline";

export default function Example({ ItinerariesFrequency, freq }) {
  const chartConfig = {
    type: "bar",
    height: 240,
    series: [
      {
        name: "Itineraries Built",
        data: ItinerariesFrequency.map(day => day.count), // Use the count from each day for chart data
      },
    ],
    options: {
      chart: {
        toolbar: {
          show: false,
        },
      },
      title: {
        show: "",
      },
      dataLabels: {
        enabled: false,
      },
      colors: ["#020617"],
      plotOptions: {
        bar: {
          columnWidth: "40%",
          borderRadius: 2,
        },
      },
      xaxis: {
        axisTicks: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        labels: {
          style: {
            colors: "#616161",
            fontSize: "12px",
            fontFamily: "inherit",
            fontWeight: 400,
          },
        },
        categories: ItinerariesFrequency.map(day => day.dayName), // Use the day name for categories
      },
      yaxis: {
        labels: {
          style: {
            colors: "#616161",
            fontSize: "12px",
            fontFamily: "inherit",
            fontWeight: 400,
          },
        },
      },
      grid: {
        show: true,
        borderColor: "#dddddd",
        strokeDashArray: 5,
        xaxis: {
          lines: {
            show: true,
          },
        },
        padding: {
          top: 5,
          right: 20,
        },
      },
      fill: {
        opacity: 0.8,
      },
      tooltip: {
        theme: "dark",
      },
    },
  };

  return (
    <Card className="w-full mt-4 ">
      <CardHeader
        floated={false}
        shadow={false}
        color="transparent"
        className="flex flex-col gap-4 rounded-none md:flex-row md:items-center"
      >
        <div className="w-max rounded-lg bg-gray-900 p-5 text-white">
          <Square3Stack3DIcon className="h-6 w-6" />
        </div>
        <div>
          <Typography variant="h6" color="blue-gray">
            {freq.charAt(0).toUpperCase() + freq.slice(1)}ly Itinerary Creation
          </Typography>
          <Typography
            variant="small"
            color="gray"
            className="max-w-sm font-normal"
          >
            Number of itineraries created each {freq=== "month" ? "month" : "day"} over the last {freq=== "month" ? "year" : "week"}.
          </Typography>
          <Typography
            variant="medium"
            color="gray"
            className="max-w-sm font-bold"
            >
            {/* Total Itineraries: {totalItineraries && totalItineraries} */}
            </Typography>
        </div>
      </CardHeader>
      <CardBody className="px-10 pb-0  w-full  ">
        <Chart options={chartConfig.options} series={chartConfig.series} type={chartConfig.type} height={chartConfig.height} />
      </CardBody>
    </Card>
  );
}
